<template>
  <div class="legal-header">
    <div class="legal-header__logo">
      <img src="https://pic3.zhuanstatic.com/zhuanzh/5495ebaa-8836-46ba-86a2-4568db42ebdd.png" alt="转转" />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
  name: 'LegalHeader'
})
</script>

<style scoped lang="scss">
.legal-header {
  width: 100%;
  background: #fff;

  &__logo {
    width: 880px;
    height: 75px;
    margin: 0 auto;
    display: flex;
    align-items: center;

    img {
      display: block;
      height: 76px;
      width: auto;
    }
  }
}
</style>
